import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import DateRangePicker from '../../Components/DateRangePicker';
import { setDate, setDateRange } from '../../store/search/actions';

class BookingDatePicker extends Component {
    render() {
      return (
        <>
            <DateRangePicker 
                from={this.props.from}
                to={this.props.to}
                setDate={this.props.setDate}
                setDateRange={this.props.setDateRange}
            />
        </>
      );
    }
  }
const mapStateToProps = (state) => ({
  
})

const mapDispatchToProps = (dispatch) => ({
    setDate: bindActionCreators(setDate, dispatch),
    setDateRange: bindActionCreators(setDateRange, dispatch),
})


export default connect(mapStateToProps, mapDispatchToProps)(BookingDatePicker);